export default __webpack_public_path__ + "static/media/W25P1002_01.7932991b.png";